import LinesSection from 'views/chat/components/sections/LinesSection.component';
import AgentsSection from 'views/chat/components/sections/AgentsSection.component';
import ConversationsSection from 'views/chat/components/sections/ConversationsSection.component';
import ConversationsExpiredSection from 'views/chat/components/sections/ConversationsExpiredSection.component';
import ConversationsUnassignedSection from 'views/chat/components/sections/ConversationsUnassignedSection.component';
import ChatSection from 'views/chat/components/sections/ChatSection.component';
import useChat from 'hooks/chat/useChat.hook';
import useComponent from 'hooks/useComponent.hook';
import { useChatSupervisorConversations } from 'hooks/chat/useChatSupervisorConversations.hook';

export default function SupervisorChatView() {
  const chat = useChat();
  const component = useComponent({
    state: {
      sectionToShow: 'AGENTS'
    }
  });

  const { data: conversations, loading } = useChatSupervisorConversations({
    lineId: chat.selected.line?.id,
    userId: chat.selected.agent?.id
  });

  const render = {
    conversationInfo: {
      isRender: false,
    },
    conversation: {
      addMessage: {
        isRender: false,
      }
    }
  }

  return (
    <div className='Chat SupervisorChat'>
      <LinesSection />
      {
        (chat.selected.line) &&
        <AgentsSection 
          onAgentSelect={(agent) => {
            if(["EXPIRED_CONVERSATIONS", "UNASSIGNED_CONVERSATIONS"].includes(agent)) {
              component.setState((state) => {state.sectionToShow = agent});
              chat.dispatch((TYPE) => {
                return {
                  type: TYPE.AGENT.SELECTED.TYPE,
                  payload: null
                }
              });
            } else {
              component.setState((state) => {state.sectionToShow = 'AGENTS'})
            }
            chat.dispatch((TYPE) => {
              return {
                type: TYPE.CONVERSATION.SELECTED.TYPE,
                payload: null
              }
            });
          }}
          activeExpiredConversations={component.state.sectionToShow === 'EXPIRED_CONVERSATIONS'}
          activeUnassignedConversations={component.state.sectionToShow === 'UNASSIGNED_CONVERSATIONS'}
        />
      }
      {
        (chat.selected.agent && component.state.sectionToShow === 'AGENTS') &&
        <ConversationsSection
          render={{
            ContactConversationsList: {
              Footer: {
                isRender: false
              }
            }
          }}
          conversations={conversations}
          loading={loading}
        />
      }
      {(chat.selected.line && component.state.sectionToShow === 'EXPIRED_CONVERSATIONS') &&
        <ConversationsExpiredSection/>
      }
      {(chat.selected.line && component.state.sectionToShow === 'UNASSIGNED_CONVERSATIONS') &&
        <ConversationsUnassignedSection/>
      }
      {
        (chat.selected.conversation) && 
        <ChatSection
          render={render}
        />
      }
    </div>
  );
}